import { CouponProgress } from './service';

interface MonitorApi {
  progress: (docId: string) => Promise<CouponProgress>;
}
interface Callbacks {
  onProgress: (progress: CouponProgress) => void;
  onEnded: () => void;
  onError: () => void;
}

// Both the live checkout and reload recovery use the same completion rule.
// Two consecutive valid local absences end the UI workflow, not prove payment.
export const watchCouponReceipt = (
  api: MonitorApi,
  docId: string,
  callbacks: Callbacks,
  immediate = false
) => {
  let stopped = false;
  let reading = false;
  let absences = 0;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const check = async () => {
    if (stopped || reading) return;
    if (timer) clearTimeout(timer);
    reading = true;
    try {
      const progress = await api.progress(docId);
      if (stopped) return;
      callbacks.onProgress(progress);
      absences = progress.active ? 0 : absences + 1;
      if (absences >= 2) {
        stopped = true;
        callbacks.onEnded();
      }
    } catch {
      if (stopped) return;
      absences = 0;
      callbacks.onError();
    } finally {
      reading = false;
      if (!stopped) timer = setTimeout(check, 5000);
    }
  };
  if (immediate) check();
  else timer = setTimeout(check, 5000);
  return {
    check,
    stop: () => {
      stopped = true;
      if (timer) clearTimeout(timer);
    },
  };
};
